module.exports = __webpack_public_path__ + "0b4ad2430eb28d564bb9516415134763.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/22-08-12babyofthebunch1-mini.jpg
// module id = 545
// module chunks = 0